var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 26.955,
    viewBox: "0 0 26.954 26.955",
    width: 26.954,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m554.68 29.09 13.477 13.478 13.477-13.478-13.477-13.477zm22.768 0-9.291 9.291-9.292-9.291 9.291-9.291z",
    fill: "#fcda70",
    transform: "translate(-554.68 -15.613)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape-1.14eac0454e76b6258684c9442c3ce692.svg";
export { ForwardRef as ReactComponent };